import React, { useState } from 'react';
import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { identity } from '../../utils/getIdentity';
import { cryptoApi } from '../../service/cryptopay-api';
import { notificationsErrorShow } from '../../redux/actions/notifications';
import '../../layout/Modal.scss';
import './Wallets2IntroModal.scss';

const Wallets2IntroModal = ({
  visible,
  onClose,
  merchantId,
  networkFilter,
  currencyIds = [],
  getMerchantWallets,
  getMerchantData,
  typeWallet = 'merchant',
  translationKey = 'wallets.wallets2Intro',
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    if (!merchantId || loading) return;

    setLoading(true);
    try {
      await cryptoApi.setupV2Wallet(merchantId);
      console.log('Setting walletVersion in getMerchantWallets payload, walletVersion: v2');
      await getMerchantWallets(merchantId, {
        typeNetwork: networkFilter,
        walletVersion: 'v2',
        order: 'DESC',
        limit: 10,
        page: 1,
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet,
        showTokens: false,
      });
      if (getMerchantData) {
        await getMerchantData(merchantId);
      }
      console.log('Setting walletVersion in localStorage.setItem, walletVersion: v2');
      localStorage.setItem('walletVersion', 'v2');
      window.dispatchEvent(new CustomEvent('walletVersionChange'));
      onClose();
    } catch (err) {
      dispatch(notificationsErrorShow(err?.data || { message: err?.message || 'Error' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t(`${translationKey}.title`)}
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable
      className={`modal modal-${identity} wallets2-intro-modal`}
      width={610}
    >
      <div className="wallets2-intro-modal__body">
        <div className='wallets2-intro-modal__content'>
          {[1,2,3].map(item => (
            <div className="wallets2-intro-modal__item" key={item}>
              <div className="wallets2-intro-modal__title">
                {t(`${translationKey}.featureTitle${item}`)}
              </div>
              <div className="wallets2-intro-modal__text">
                {t(`${translationKey}.featureText${item}`)}
              </div>
            </div>
          ))}
        </div>
        <button
          type="button"
          disabled={loading}
          className={`wallets2-intro-modal__start wallets2-intro-modal__start-${identity}`}
          onClick={handleStart}
        >
          {loading ? <LoadingOutlined spin /> : t(`${translationKey}.startButton`)}
        </button>
      </div>
    </Modal>
  );
};

export default Wallets2IntroModal;
